import React, { useState, useEffect } from 'react';
import { addArticle, loadArticle, updateArticle } from '../../../api/articles';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useHistory, useLocation } from 'react-router-dom';
import { ROUTES } from '../../../config/routes';
import ReactQuillNew from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';

const CreateArticle = () => {
  const [articleData, setArticleData] = useState({
    title: '',
    category: '', // Added category field
    description: '',
    date: '',
    image: null,
  });
  const [isUpdate, setIsUpdate] = useState(false);
  const [loading, setLoading] = useState(false);
  const [, setError] = useState('');
  const [isHtmlMode, setIsHtmlMode] = useState(false); // New state for toggle
  const history = useHistory();
  const location = useLocation();

  const getQueryParams = (query) => {
    return new URLSearchParams(query);
  };

  useEffect(() => {
    const queryParams = getQueryParams(location.search);
    const aid = queryParams.get('aid');

    if (aid) {
      setIsUpdate(true);
      // Fetch the existing article data
      const fetchArticle = async () => {
        try {
          setLoading(true);
          const article = await loadArticle(aid);

          setArticleData({
            id: article.id,
            title: article.title,
            category: article.category || '', // Added category with fallback
            date: new Date(article.date).toISOString().slice(0,16), // updated to include time
            description: article.description,
            image: article.image,
          });
          setLoading(false);
        } catch (error) {
          setError('Failed to fetch article data');
          setLoading(false);
        }
      };
      fetchArticle();
    }
  }, [location.search]);

  const handleChange = (e) => {
    const { id, value, files } = e.target;
    if (id === 'image') {
      setArticleData((prevData) => ({
        ...prevData,
        image: files[0],
      }));
    } else {
      setArticleData((prevData) => ({
        ...prevData,
        [id]: value,
      }));
    }
  };

  const updateDescription = (description) => {
    setArticleData((prevData) => ({
      ...prevData,
      description: description,
    }));
  };

  const toggleEditMode = () => {
    setIsHtmlMode(!isHtmlMode);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      if (isUpdate) {
        // Update existing article
        await updateArticle(articleData);
        toast.success('Article mis à jour avec succès');
      } else {
        // Create new article
        await addArticle(articleData);
        toast.success('Article créé avec succès');
      }
      setTimeout(() => {
        history.push(ROUTES.ALL_ARTICLES.path);
      }, 3000);
    } catch (error) {
      console.error('Erreur lors de l\'édition:', error);
      setError('Echec de l\'édition de l\'article');
      toast.error('Echec de la création/mise à jour de l\'article. Veuillez réessayer.');
    } finally {
      setLoading(false);
    }
  };

  const handleBack = () => {
    history.push(ROUTES.ALL_ARTICLES.path);
  };

  return (
    <div className="contact-wrapper overflow-hidden">
      <ToastContainer />
      <div className="container pt-120 position-relative">
        <div className="row">
          <div className="col-lg-8"></div>
          <div className="create-article-container">
            <h2 className='mb-3'>{isUpdate ? 'Mise à jour article' : 'Creation article'}</h2>
            <form className="create-article-form" onSubmit={handleSubmit}>
              <label>Title:</label>
              <input
                type="text"
                id="title"
                className="form-control mb-3"
                value={articleData.title}
                onChange={handleChange}
                required
              />
              
              <label>Category:</label>
              <input
                type="text"
                id="category"
                className="form-control mb-3"
                value={articleData.category}
                onChange={handleChange}
                required
              />
              
              <label>Date:</label>
              <input
                type="datetime-local"  // changed from "date"
                id="date"
                className="form-control mb-3"
                value={articleData.date}
                onChange={handleChange}
                required
              />
              <div className="d-flex align-items-center justify-content-between mb-2">
                <label className="mb-0">Description:</label>
                <button 
                  type="button" 
                  className="btn btn-sm btn-outline-secondary" 
                  onClick={toggleEditMode}
                >
                  {isHtmlMode ? 'Mode Visuel' : 'Mode HTML'}
                </button>
              </div>
              
              {isHtmlMode ? (
                <textarea
                  className="form-control mb-3"
                  value={articleData.description}
                  onChange={(e) => updateDescription(e.target.value)}
                  rows={10}
                />
              ) : (
                <ReactQuillNew
                  id="description"
                  value={articleData.description}
                  onChange={updateDescription}
                />
              )}
              
              <label>Image:</label>
              {articleData.image && (
                <div className="mb-3">
                  <img
                    src={typeof articleData.image === 'string' ? articleData.image : URL.createObjectURL(articleData.image)}
                    alt="Article"
                    className="img-fluid mb-3"
                    style={{ maxHeight: '200px' }}
                  />
                </div>
              )}
              <input
                type="file"
                id="image"
                className="mb-3"
                accept="image/*"
                onChange={handleChange}
                required={!isUpdate}
              />
              <br />
              <div className="submit-btn">
                <button type="submit" disabled={loading} className="btn btn-primary">
                  {loading ? 'En cours de création...' : isUpdate ? 'Mettre à jour l\'article' : 'Créer article'}
                </button>
              </div>
              <br />
              <div className="submit-btn">
                <button type="button" onClick={handleBack} className="btn btn-secondary">
                  <i className="bi bi-arrow-left" title="Retour aux Articles"></i>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateArticle;